
import { minus as npMinus } from 'number-precision'

export default {
  filters: {
    differencePrice(a, curDecoVal, indexDecoVal, poaConfig) {
      const rep = /^[0-9]+(\.[0-9]*)?$/
      if (!rep.test(a)) {
        return a || 'Waived';
      }

      if (poaConfig.includes(curDecoVal) || poaConfig.includes(indexDecoVal)) {
        if (curDecoVal === '111' || curDecoVal === '111.00' || indexDecoVal === '111' || indexDecoVal === '111.00') {
          return '-';
        } else if (curDecoVal === '999' || curDecoVal === '999.00' || indexDecoVal === '999' || indexDecoVal === '999.00') {
          return 'POA';
        }
      } else if (curDecoVal === indexDecoVal) {
          return 0;
      } else if (+curDecoVal > +indexDecoVal) {
        return `-£ ${npMinus(curDecoVal, indexDecoVal)}`;
      } else if (+curDecoVal < +indexDecoVal) {
        return `+£ ${npMinus(indexDecoVal, curDecoVal)}`;
      } else {
        return 'Waived';
      }
    }

  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tableColumns: {
      type: Array,
      default: () => [],
    },
    tableType: {
      type: String,
      default: '',
    },
    curDecoration: {
      type: Object,
      default: () => { },
    },
    indexDecoration: {
      type: Object,
      default: () => { },
    },
    comLocationNum: {
      type: Number,
      default: 1,
    },
    curOrder: {
      type: String,
      default: '',
    },
    min: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      poaConfig: ['111', '111.00', '999', '999.00'],
    }
  },
  methods: {
    getNumber(e, index) {
        if (parseInt(e.target.value) < this.min) {
            this.$emit('send-idx', index);
        }
      },
    },
  computed: {
    comWidth(){
      return 800/this.tableColumns.length - 1
    }
  }
}
